export enum DataTableMode {
  DEFAULT = 'default',
  SEARCH = 'search',
  ERROR = 'error',
}
